export const LEGAL_RIGHT_OF_CANCELLATION: string = `

### <!--= ++sectionIndex -->. Right of Cancellation

In accordance with your legal rights, you are entitled to cancel this contract at any time, without the necessity to provide any reason for the cancellation.

To action your right of cancellation, you are required to contact us with a clear statement (e.g., an email) indicating your decision to cancel. Please direct your cancellation to:

<!-- for (const addressLine of company.address) { -->
<!--= addressLine -->
<!-- } -->

Phone / WhatsApp Business: <!--= company.phone -->
E-Mail: <!--= company.mail -->

For processing your request, please include the following information:

- Your full name
- Your email address
- The product or service you wish to cancel

This will assist us in verifying your identity and process your cancellation effectively. As an alternative, you may also exercise your right of cancellation directly through your user account, as detailed in **2. Cancellation Procedure**.
`;
